var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"generic"},[_c(_vm.comp,_vm._b({tag:"component",staticClass:"inner",on:{"emitAddElement":_vm.addElement,"emitDeleteElement":_vm.removeElement,"saveValue":value => _vm.saveElement(value)}},'component',_vm.props,false)),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }